var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 1024C229.701818 1024 0 794.298182 0 512S229.701818 0 512 0c282.321455 0 512 229.701818 512 512S794.344727 1024 512 1024zM512 44.520727C254.231273 44.520727 44.544 254.208 44.544 512c0 257.768727 209.710545 467.479273 467.479273 467.479273 257.792 0 467.479273-209.733818 467.479273-467.479273C979.502545 254.208 769.792 44.520727 512 44.520727z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M666.693818 692.177455c-5.701818 0-11.403636-2.164364-15.755636-6.493091L342.690909 377.390545c-8.704-8.704-8.704-22.784 0-31.488 8.704-8.704 22.784-8.704 31.488 0L682.426182 654.196364c8.704 8.680727 8.704 22.784 0 31.488C678.097455 690.013091 672.418909 692.177455 666.693818 692.177455z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M354.048 692.200727c-5.701818 0-11.380364-2.187636-15.732364-6.493091-8.704-8.704-8.704-22.784 0-31.488L654.196364 338.338909c8.704-8.704 22.784-8.704 31.488 0 8.680727 8.704 8.680727 22.784 0 31.488L369.803636 685.707636C365.451636 690.013091 359.749818 692.200727 354.048 692.200727z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.11e3d16f10a4ca8db2cf972dc410fd98.svg";
export { ForwardRef as ReactComponent };